export default __webpack_public_path__ + "static/media/dx_071102.16824c52.jpg";